import { UserGroup } from "admin/types/interfaces/user";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useGroups = (
  { searchQuery, enabled = true }: { searchQuery?: string; enabled?: boolean } = {},
  options?: SWRConfiguration
) => {
  const url = enabled
    ? `${ACCESS_CONTROLLER_V1}/user-tags${searchQuery ? `?q=${searchQuery}` : ""}`
    : null;
  return useV1List<UserGroup>(url, options);
};

export default useGroups;
